import React, { useContext } from "react";
import { BoxProps, OutlinedTextFieldProps, Box, TextField } from "@mui/material";
import { FormFieldContext } from "./FormField";
import { deepmerge } from "@mui/utils";

interface FormFieldTextField {
  containerProps?: ContainerProps;
  textFieldProps?: TextFieldProps;
  required?: boolean;
  onSetFieldValue?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

type ContainerProps = Partial<BoxProps>;
const defaultContainerProps: ContainerProps = {};

type TextFieldProps = Partial<OutlinedTextFieldProps>;
const defaultTextFieldProps: TextFieldProps = {
  fullWidth: true,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const FormFieldTextField = ({
  textFieldProps = {},
  containerProps = {},
  required = false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSetFieldValue = () => {},
}: FormFieldTextField) => {
  const contextProps = useContext(FormFieldContext);

  if (!contextProps) throw new Error();

  const {
    field: { onChange, name },
    meta: { value },
  } = contextProps;

  const mergedContainerProps = deepmerge(defaultContainerProps, containerProps);
  const mergedTextFieldProps = deepmerge(defaultTextFieldProps, textFieldProps);
  return (
    <Box {...mergedContainerProps}>
      <TextField
        variant="standard"
        name={name}
        id={name}
        value={value}
        slotProps={{
          input: { "aria-required": required },
        }}
        onChange={(e) => {
          onChange(e);
          onSetFieldValue(e);
        }}
        {...mergedTextFieldProps}
      />
    </Box>
  );
};
